import { render, staticRenderFns } from "./BaggageCreateComponent.vue?vue&type=template&id=89f9395e"
import script from "./create.js?vue&type=script&lang=js&external"
export * from "./create.js?vue&type=script&lang=js&external"
import style0 from "./BaggageCreateComponent.vue?vue&type=style&index=0&id=89f9395e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports